import { useStaticQuery, graphql } from "gatsby"

export const useHomepageContent = () => {
  const { allHomepage } = useStaticQuery(
    graphql`
      query HomePageContent {
        allHomepage {
          nodes {
            videos {
              url
            }
            image {
              image {
                local {
                  childImageSharp {
                    fluid(maxWidth: 1000, quality: 85, srcSetBreakpoints: [400, 600, 800, 1000]) {
                        ...GatsbyImageSharpFluid_withWebp
                        presentationHeight
                        presentationWidth
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  )
  return allHomepage.nodes[0]
}